import { FilterOutlined } from "@ant-design/icons"
import { Flex, Select } from "antd"
import React from "react"

import { SearchBar } from "../../../../components/Input/SearchBar"
import SelectComponent from "../../../../components/Select"
import { useAppSelector } from "../../../../hooks/use-app-selector.ts"
import {
  selectAccessibleBranches,
  selectIsCompanyMode
} from "../../../Branches/redux/branches.slice.ts"
import type {
  TeamMembersFilterOptions,
  TeamMembersFilters
} from "../../redux/team-members.types.ts"

interface TeamMembersListFiltersProps {
  filters: TeamMembersFilters
  filterOptions: TeamMembersFilterOptions | null
  onFilterChange: (filters: Partial<TeamMembersFilters>) => void
  onSearchChange?: (value: string | null) => void
}

export function TeamMembersListFilters({
  filters,
  filterOptions,
  onSearchChange,
  onFilterChange
}: TeamMembersListFiltersProps) {
  const accessibleBranches = useAppSelector(selectAccessibleBranches)
  const isCompanyMode = useAppSelector(selectIsCompanyMode)

  // Cause for a certain role there's disabled
  const labels = filterOptions?.["labels"]?.map((option) => ({
    value: option?.value,
    label: option?.label
  }))

  const onFilterChangeHandler =
    (key: keyof TeamMembersFilters) => (value: unknown) => {
      onFilterChange({ [key]: value || null })
    }

  const teamIds = filters?.team_ids ? filters.team_ids.split(",") : []

  return (
    <Flex wrap="wrap" gap="small">
      {onSearchChange && (
        <div className={"flex-1 max-md:basis-60 max-md:grow"}>
          <SearchBar
            placeholder="Search team members"
            defaultValue={filters?.q as string}
            onSearch={onSearchChange}
          />
        </div>
      )}
      {isCompanyMode && accessibleBranches.length > 1 && (
        <Select
          mode="multiple"
          placeholder="Branches: All branches"
          value={teamIds}
          onChange={(value: string[]) =>
            onFilterChange({ team_ids: value.length ? value.join(",") : null })
          }
          className={"max-md:basis-full w-56"}
          suffixIcon={<FilterOutlined />}
          allowClear
          maxTagCount="responsive"
          options={accessibleBranches.map((b) => ({
            value: b.id,
            label: b.name
          }))}
        />
      )}
      <SelectComponent
        placeholder="Filter by role"
        value={filters?.labels}
        onChange={onFilterChangeHandler("labels")}
        className={"max-md:basis-full w-44"}
        suffixIcon={<FilterOutlined />}
        allowClear
        options={labels}
        optionFilterType="filter"
      />
      <SelectComponent
        placeholder="Filter by status"
        value={filters?.status}
        onChange={onFilterChangeHandler("status")}
        className={"max-md:basis-full w-40"}
        suffixIcon={<FilterOutlined />}
        allowClear
        options={filterOptions?.["status"]}
        optionFilterType="filter"
      />
    </Flex>
  )
}
